import Facet, {
    FacetValue,
    LegacyFacetQueryParameters,
} from "../types/funnelback/Facets";

export type FacetParamFromToggleUrl = {
    queryStringParamName: string;
    queryStringParamValue: string;
};

const getLegacyFacetQueryParameters = (
    facet: Facet
): LegacyFacetQueryParameters => {
    const legacy = facet.customData?.legacyFacetQueryParameters;
    if (legacy && typeof legacy === "object") {
        return legacy as LegacyFacetQueryParameters;
    }
    return {};
};

export const parseFacetParamFromToggleUrl = (
    toggleUrl: string
): FacetParamFromToggleUrl | null => {
    const query = toggleUrl.startsWith("?") ? toggleUrl.slice(1) : toggleUrl;
    const params = new URLSearchParams(query);

    for (const [key, value] of params.entries()) {
        if (key.startsWith("f.") || key.startsWith("ge_") || key.startsWith("le_")) {
            return {
                queryStringParamName: key,
                queryStringParamValue: value,
            };
        }
    }

    return null;
};

export const getFacetValues = (facet: Facet): FacetValue[] => {
    if (facet.allValues?.length) {
        return facet.allValues;
    }
    return facet.categories?.[0]?.values ?? [];
};

export const getFacetParamName = (facet: Facet): string => {
    const fromCategory = facet.categories?.[0]?.queryStringParamName;
    if (fromCategory) {
        return fromCategory;
    }

    const legacyParams = getLegacyFacetQueryParameters(facet);
    const firstLegacy = Object.values(legacyParams)[0];
    if (firstLegacy?.queryStringParamName) {
        return firstLegacy.queryStringParamName;
    }

    const values = getFacetValues(facet);
    for (const value of values) {
        if (value.queryStringParamName) {
            return value.queryStringParamName;
        }
        const parsed = value.toggleUrl
            ? parseFacetParamFromToggleUrl(value.toggleUrl)
            : null;
        if (parsed?.queryStringParamName) {
            return parsed.queryStringParamName;
        }
    }

    return "";
};

export const getFacetParamValue = (facet: Facet, value: FacetValue): string => {
    if (value.queryStringParamValue) {
        return value.queryStringParamValue;
    }

    const legacy = getLegacyFacetQueryParameters(facet)[value.data];
    if (legacy?.queryStringParamValue) {
        return legacy.queryStringParamValue;
    }

    const parsed = value.toggleUrl
        ? parseFacetParamFromToggleUrl(value.toggleUrl)
        : null;
    if (parsed?.queryStringParamValue) {
        return parsed.queryStringParamValue;
    }

    return value.data;
};
